/**
 * Single source of truth for the API origin.
 *
 * Every REST client (main API, account API, JIRA API) resolves its endpoint
 * here so a deployment only has to set REACT_APP_API_URL once. The app talks
 * to the backend over polling, not WebSocket, so there is no WS equivalent.
 */

/** Custom domain whose API lives on an api.* subdomain. */
const CUSTOM_DOMAIN = 'm19cmjigen.com';

const resolveApiBaseUrl = (): string => {
  // 独自ドメインは api.* サブドメインにAPIがあるため最優先で判定する
  if (window.location.hostname === CUSTOM_DOMAIN) {
    return `https://api.${CUSTOM_DOMAIN}`;
  }

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
    return 'http://localhost:8080';
  }

  // フロントエンドと同一オリジンでAPIが提供されている構成向け
  return window.location.origin;
};

export const API_BASE_URL = resolveApiBaseUrl();

/** Versioned REST base, e.g. "https://api.example.com/api/v1". */
export const API_V1_URL = `${API_BASE_URL}/api/v1`;
